/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalibrationDataOverviewDto,
  CreateQaEquipmentRtSystemDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100ForbiddenException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  HistoryDto,
  ODataPostProcessedResultsOfEquipmentTypeCatalogDto,
  ODataPostProcessedResultsOfQaEquipmentRtSystemDto,
  QaEquipmentCatalogDto,
  QaEquipmentRtSystemDto,
} from '../models/index';
import {
    CalibrationDataOverviewDtoFromJSON,
    CalibrationDataOverviewDtoToJSON,
    CreateQaEquipmentRtSystemDtoFromJSON,
    CreateQaEquipmentRtSystemDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100ForbiddenExceptionFromJSON,
    ErrorResponseOfPtw100ForbiddenExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON,
    ODataPostProcessedResultsOfEquipmentTypeCatalogDtoToJSON,
    ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSON,
    ODataPostProcessedResultsOfQaEquipmentRtSystemDtoToJSON,
    QaEquipmentCatalogDtoFromJSON,
    QaEquipmentCatalogDtoToJSON,
    QaEquipmentRtSystemDtoFromJSON,
    QaEquipmentRtSystemDtoToJSON,
} from '../models/index';

export interface ActivateNewCalibrationDataRequest {
    id: string;
}

export interface CreateQaEquipmentRtSystemRequest {
    createQaEquipmentRtSystemDto?: CreateQaEquipmentRtSystemDto;
}

export interface DeleteQaEquipmentRtSystemRequest {
    id: string;
}

export interface GetQaEquipmentCalibrationDataRequest {
    id: string;
}

export interface GetQaEquipmentHistoryRequest {
    id: string;
}

export interface GetQaEquipmentOptionsRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetQaEquipmentRtSystemRequest {
    id: string;
}

export interface GetQaEquipmentRtSystemListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetQaEquipmentTemplateRequest {
    optionId: string;
}

export interface UpdateQaEquipmentRtSystemRequest {
    id: string;
    createQaEquipmentRtSystemDto?: CreateQaEquipmentRtSystemDto;
}

export interface ValidateQaEquipmentRtSystemRequest {
    createQaEquipmentRtSystemDto?: CreateQaEquipmentRtSystemDto;
}

/**
 * 
 */
export class QaEquipmentApi extends runtime.BaseAPI {

    /**
     */
    async activateNewCalibrationDataRaw(requestParameters: ActivateNewCalibrationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling activateNewCalibrationData().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/activate-calibration-data`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async activateNewCalibrationData(requestParameters: ActivateNewCalibrationDataRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['activateNewCalibrationDataRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.activateNewCalibrationDataRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async createQaEquipmentRtSystemRaw(requestParameters: CreateQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQaEquipmentRtSystemDtoToJSON(requestParameters['createQaEquipmentRtSystemDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 201: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue), "QaEquipmentRtSystemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async createQaEquipmentRtSystem(requestParameters: CreateQaEquipmentRtSystemRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['createQaEquipmentRtSystemRaw']>>, QaEquipmentRtSystemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = QaEquipmentRtSystemDto;

         const response = this.createQaEquipmentRtSystemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async deleteQaEquipmentRtSystemRaw(requestParameters: DeleteQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteQaEquipmentRtSystem().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async deleteQaEquipmentRtSystem(requestParameters: DeleteQaEquipmentRtSystemRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['deleteQaEquipmentRtSystemRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.deleteQaEquipmentRtSystemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getAllQaEquipmentCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QaEquipmentCatalogDtoFromJSON), "QaEquipmentCatalogDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QaEquipmentCatalogDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getAllQaEquipmentCatalog(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getAllQaEquipmentCatalogRaw']>>, Array<QaEquipmentCatalogDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<QaEquipmentCatalogDto>;

         const response = this.getAllQaEquipmentCatalogRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentCalibrationDataRaw(requestParameters: GetQaEquipmentCalibrationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQaEquipmentCalibrationData().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/calibration-data`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => CalibrationDataOverviewDtoFromJSON(jsonValue), "CalibrationDataOverviewDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => CalibrationDataOverviewDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentCalibrationData(requestParameters: GetQaEquipmentCalibrationDataRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getQaEquipmentCalibrationDataRaw']>>, CalibrationDataOverviewDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = CalibrationDataOverviewDto;

         const response = this.getQaEquipmentCalibrationDataRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentHistoryRaw(requestParameters: GetQaEquipmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQaEquipmentHistory().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON), "HistoryDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentHistory(requestParameters: GetQaEquipmentHistoryRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getQaEquipmentHistoryRaw']>>, Array<HistoryDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<HistoryDto>;

         const response = this.getQaEquipmentHistoryRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentOptionsRaw(requestParameters: GetQaEquipmentOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfEquipmentTypeCatalogDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentOptions(requestParameters: GetQaEquipmentOptionsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getQaEquipmentOptionsRaw']>>, ODataPostProcessedResultsOfEquipmentTypeCatalogDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfEquipmentTypeCatalogDto;

         const response = this.getQaEquipmentOptionsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentRtSystemRaw(requestParameters: GetQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQaEquipmentRtSystem().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue), "QaEquipmentRtSystemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentRtSystem(requestParameters: GetQaEquipmentRtSystemRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getQaEquipmentRtSystemRaw']>>, QaEquipmentRtSystemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = QaEquipmentRtSystemDto;

         const response = this.getQaEquipmentRtSystemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentRtSystemListRaw(requestParameters: GetQaEquipmentRtSystemListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfQaEquipmentRtSystemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentRtSystemList(requestParameters: GetQaEquipmentRtSystemListRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getQaEquipmentRtSystemListRaw']>>, ODataPostProcessedResultsOfQaEquipmentRtSystemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfQaEquipmentRtSystemDto;

         const response = this.getQaEquipmentRtSystemListRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentTemplateRaw(requestParameters: GetQaEquipmentTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['optionId'] == null) {
            throw new runtime.RequiredError(
                'optionId',
                'Required parameter "optionId" was null or undefined when calling getQaEquipmentTemplate().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/template/{optionId}`.replace(`{${"optionId"}}`, encodeURIComponent(String(requestParameters['optionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => CreateQaEquipmentRtSystemDtoFromJSON(jsonValue), "CreateQaEquipmentRtSystemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => CreateQaEquipmentRtSystemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentTemplate(requestParameters: GetQaEquipmentTemplateRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['getQaEquipmentTemplateRaw']>>, CreateQaEquipmentRtSystemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = CreateQaEquipmentRtSystemDto;

         const response = this.getQaEquipmentTemplateRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async updateQaEquipmentRtSystemRaw(requestParameters: UpdateQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateQaEquipmentRtSystem().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQaEquipmentRtSystemDtoToJSON(requestParameters['createQaEquipmentRtSystemDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue), "QaEquipmentRtSystemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async updateQaEquipmentRtSystem(requestParameters: UpdateQaEquipmentRtSystemRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['updateQaEquipmentRtSystemRaw']>>, QaEquipmentRtSystemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = QaEquipmentRtSystemDto;

         const response = this.updateQaEquipmentRtSystemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async validateQaEquipmentRtSystemRaw(requestParameters: ValidateQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQaEquipmentRtSystemDtoToJSON(requestParameters['createQaEquipmentRtSystemDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async validateQaEquipmentRtSystem(requestParameters: ValidateQaEquipmentRtSystemRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentApi['validateQaEquipmentRtSystemRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateQaEquipmentRtSystemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
